import { useMutation } from '@tanstack/react-query'
import { enableCustomerRewardsDistribution } from 'services/EarnService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { useEarnTracking } from '../useEarnTracking'

export const useDistributeCustomerRewards = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useEarnTracking()
  const { mutate: distributeCustomerRewards, isPending: isDistributingCustomerRewardsPending } =
    useMutation({
      mutationFn: enableCustomerRewardsDistribution,
    })

  const handleDistributeCustomerRewards = (
    productId: string,
    reference: string,
    authenticationCode: string
  ) => {
    return distributeCustomerRewards(
      { productId, reference, authenticationCode },
      {
        onSuccess: () => {
          trackSuccess('distribute')
          onSuccess?.()
        },
        onError: (error: BaseErrorResponse) => {
          trackError('distribute', error)
          onError?.(error)
        },
      }
    )
  }

  return {
    distributeCustomerRewards: handleDistributeCustomerRewards,
    isDistributingCustomerRewardsPending,
  }
}
